// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tab[data-v-6c1229ea]{text-transform:capitalize}.v-tab--active[data-v-6c1229ea]{color:#ff6900}.init-in-progress-icon[data-v-6c1229ea]{margin:80px 0 120px}.form-wrapper[data-v-6c1229ea]{min-height:400px}.time[data-v-6c1229ea]{white-space:nowrap}.tab-items-container[data-v-6c1229ea]{background-color:#fff}", ""]);
// Exports
module.exports = exports;
